import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { ROUTES } from '../../../constants';
import { infoAlert } from '../../../contexts/AlertContext';
import { useBillingAccess } from '../../../hooks/useBillingAccess';
import { LoaderSmall } from '../LoaderSmall';

const BillingAccessGate = ({ children }) => {
  const { isResolved, canViewBilling, loadFailed } = useBillingAccess();
  const denied = isResolved && !canViewBilling;

  useEffect(() => {
    if (!denied) return;
    if (loadFailed) {
      infoAlert('Access restricted', "We couldn't verify your access to billing. Please try again later.");
    } else {
      infoAlert('Access restricted', 'You do not have permission to view billing information.');
    }
  }, [denied, loadFailed]);

  if (!isResolved) {
    return <LoaderSmall color="inherit" size="1.35em" />;
  }

  if (denied) {
    return <Redirect to={ROUTES.ROUTE_DASHBOARD.path} />;
  }

  return children;
};

export default BillingAccessGate;
